import { render, staticRenderFns } from "./HomeAsk.vue?vue&type=template&id=0d4eca56&scoped=true&"
import script from "./HomeAsk.vue?vue&type=script&lang=js&"
export * from "./HomeAsk.vue?vue&type=script&lang=js&"
import style0 from "./HomeAsk.vue?vue&type=style&index=0&id=0d4eca56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4eca56",
  null
  
)

export default component.exports